import React from "react";

import { IComments } from "../../lib/models/IComment";

import { CommentsContextWrapper } from "./CommentsContext";
import CommentsBox from "./CommentsBox";
import CommentsList from "./CommentsList";

interface IProps {
  data: IComments;
  isAuthenticated: boolean;
}

const Comments = ({ data, isAuthenticated }: IProps) => (
  <CommentsContextWrapper initialState={data.comments}>
    <CommentsBox
      heading={data.heading}
      notes={data.notes}
      showHeading={data.showHeading}
      isAuthenticated={isAuthenticated}
      pageId={data.pageId}
    />
    <CommentsList />
  </CommentsContextWrapper>
);

export default Comments;
